// extracted by mini-css-extract-plugin
export default {"filtrRez":"FiltrtagCloudMoby_filtrRez__HGsY1","itemFiltrRez":"FiltrtagCloudMoby_itemFiltrRez__XFV9p"};